import Swal from "sweetalert2";
import { CAREERS } from "../data/constants";
import { RESULT_TEMPLATES } from "../data/resultTemplates";

export default function ShareCTA({ result }) {
  const careerName = CAREERS[result.careerKey];
  const shortName = (RESULT_TEMPLATES[result.careerKey]?.title || careerName)
    .replace(/\(.*?\)/g, "")
    .trim();

  const quizUrl = `${window.location.origin}/psytest`; // 你的測驗入口
  const shareText = `我最適合的 CPA 職涯的結果是「${shortName}」！快來測測看你適合成為哪一類會計師吧！\n${quizUrl}`;

  const handleShare = async () => {
    // 優先走系統分享
    if (navigator.share) {
      try {
        await navigator.share({
          title: "CPA 職涯導航測驗",
          text: shareText,
        });
        return;
      } catch (e) {
        // 使用者取消也會進來，直接 fallback 複製即可
      }
    }

    // fallback：複製文字
    try {
      await navigator.clipboard.writeText(shareText);
      Swal.fire({
        imageUrl: "/member_img/logo.svg",
        confirmButtonColor: "#224040",
        color: "#224040",
        text: "已複製分享文字，貼到 LINE/IG 就可以分享囉！",
      });
    } catch (e) {
      // 再 fallback：alert
      alert("複製失敗，請手動複製：\n\n" + shareText);
    }
  };

  return (
    <div className="share-cta">
      <h3 className="mt-5">想把結果分享給朋友？</h3>

      {/* 2) 一鍵分享文字 */}
      <button type="button" className="action-button" onClick={handleShare}>
        分享結果
      </button>
    </div>
  );
}